// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"az_-qd","syndicatedContainer":"az_-rd"};